import { Collapse } from 'antd';
import type { CollapseProps } from 'antd';
import styled from 'styled-components';

const StyledAntCollapse = styled(Collapse)`
  &&& {
    background: transparent;
    border: none;

    > .ant-collapse-item {
      background: #ffffff;
      border: 1px solid #e6e8ee;
      border-radius: 16px;
      box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);
      overflow: hidden;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      > .ant-collapse-header {
        padding: 16px;
        align-items: center;
        cursor: pointer;

        .ant-collapse-header-text {
          font-weight: 600;
          font-size: 16px;
          color: #0f1729;
        }

        .ant-collapse-expand-icon {
          color: rgba(15, 23, 41, 0.45);

          .anticon {
            transition: transform 0.16s ease;
          }
        }
      }

      > .ant-collapse-content {
        border-top: 1px solid #eef0f4;

        > .ant-collapse-content-box {
          padding: 16px;
        }
      }
    }
  }
`;

const StyledCollapse = (props: CollapseProps) => (
  <StyledAntCollapse
    {...props}
    bordered={false}
    expandIconPosition="end"
    className={['titan-collapse', props.className].filter(Boolean).join(' ')}
  />
);

export default StyledCollapse;
